import { SearchScenarioId } from 'owa-search-next-common';
import { Suggestion } from 'owa-search-service';
import { action } from 'satcheljs';

const onSuggestionSelected = action(
    'onSuggestionSelected',
    (
        scenarioId: SearchScenarioId,
        suggestion: Suggestion,
        actionSource: string,
        suggestionSetTraceId: string,
        index: number
    ) => ({
        suggestion,
        actionSource,
        scenarioId,
        suggestionSetTraceId,
        index,
    })
);

export default onSuggestionSelected;
